import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { service } from '@ember/service';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import CompactQuickFilter from 'rise-ui/components/compact-quick-filter.gjs';
import fnx from 'rise-ui/helpers/fnx.js';
import nom from 'rise-ui/helpers/nom.js';

export default class TimeSeriesSelectionLineLocationComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;

  <template>
    <div class="c-time-series-selection-line c-time-series-selection-line-location c-lined__line"
      ...attributes
    >
      <div class="c-time-series-selection-line__wrapper">
        <span role="button"
          class="c-time-series-selection-line-actions dummy-button"
          {{on "click" (stopPropagation)}}
        >
          <span class="c-time-series-selection-line-actions__filter">
            <CompactQuickFilter
              @compactTitle="Quick Filter Location"
              @action={{fnx this.selectedLocations.quickFilterLocation @location.id}}
            />
          </span>{{nom~}}
        </span>
        <span class="c-time-series-selection-line__type">Location</span>
        <span class="c-time-series-selection-line__label">{{@location.name}}</span>
      </div>
    </div>
  </template>
}
